export function validate(values) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const errors = { hook: {} };
    if (!values) {
        return errors;
    }
    if (!((_b = (_a = values === null || values === void 0 ? void 0 : values.hook) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.trim())) {
        errors.hook.title = 'Please add a title';
    }
    if (!((_d = (_c = values === null || values === void 0 ? void 0 : values.hook) === null || _c === void 0 ? void 0 : _c.api_key) === null || _d === void 0 ? void 0 : _d.trim())) {
        errors.hook.api_key = 'Please add an api key';
    }
    if (!((_f = (_e = values === null || values === void 0 ? void 0 : values.hook) === null || _e === void 0 ? void 0 : _e.password) === null || _f === void 0 ? void 0 : _f.trim())) {
        errors.hook.password = 'Please add an api password';
    }
    if (!((_h = (_g = values === null || values === void 0 ? void 0 : values.hook) === null || _g === void 0 ? void 0 : _g.shopifySubdomain) === null || _h === void 0 ? void 0 : _h.trim())) {
        errors.hook.shopifySubdomain = 'Please add a shopify subdomain';
    }
    else {
        const invalidProtocols = ['https://', 'http://'];
        const protocol = invalidProtocols.find((value) => values.hook.shopifySubdomain.includes(value));
        const hasTrailingSlash = values.hook.shopifySubdomain.endsWith('/');
        const protocolErrorMessage = protocol
            ? `Please remove the protocol \`${protocol}\` from the hostname`
            : '';
        const trailingSlashErrorMessage = hasTrailingSlash
            ? 'Please remove the trailing `/` from the hostname'
            : '';
        if (protocolErrorMessage) {
            errors.hook.shopifySubdomain = protocolErrorMessage;
        }
        if (trailingSlashErrorMessage) {
            errors.hook.shopifySubdomain = trailingSlashErrorMessage;
        }
        if (protocolErrorMessage && trailingSlashErrorMessage) {
            errors.hook.shopifySubdomain = `Please remove the protocol \`${protocol}\` and the trailing \`/\` from the hostname`;
        }
    }
    if (!(values === null || values === void 0 ? void 0 : values.template)) {
        errors.template = 'Please add some template content';
    }
    return errors;
}
export const apiKeyHelpText = `Please insert the API key corresponding to the Shopify account that you want Dixa to receive data from.`;
export const apiPasswordHelpText = `Please insert the API Password corresponding to the Shopify account that you want Dixa to receive data from.`;
export const subdomainHelpText = 'Please insert your Shopify subdomain name here. Example: `mydomain.shopify.com`';
